var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22080_156436)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22080_156436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8114 16.6878C29.4262 16.3024 28.8139 16.2781 28.3998 16.6155C28.3399 16.6643 28.3863 16.6213 27.4746 17.533L29.8412 19.8997L30.6917 19.0597C31.1029 18.6485 31.1029 17.9794 30.6917 17.5682L29.8114 16.6878Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6213 22.431L21.2292 25.4142C21.1354 25.6151 21.1773 25.8533 21.3341 26.0101C21.4909 26.1669 21.7292 26.2088 21.93 26.115L24.9132 24.7229C25.0312 24.6678 24.6739 25.0022 29.0905 20.6407L26.7286 18.2788C22.3496 22.6578 22.6775 22.3107 22.6213 22.431Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8012 25.3709C25.6721 25.4984 25.5232 25.6019 25.3588 25.6786L22.3756 27.0708C21.789 27.3446 21.0724 27.2403 20.588 26.7559C20.1194 26.2872 19.9928 25.5688 20.273 24.9681L21.6652 21.9849C21.7434 21.8174 21.8493 21.6662 21.9801 21.5354L26.4648 17.0506V12.582C26.4648 11.7097 25.7551 11 24.8828 11H14.582C13.7097 11 13 11.7097 13 12.582V27.418C13 28.2903 13.7097 29 14.582 29H24.8828C25.7551 29 26.4648 28.2903 26.4648 27.418V24.7155L25.8012 25.3709ZM15.8125 14.4102H23.6875C23.9788 14.4102 24.2149 14.6463 24.2149 14.9375C24.2149 15.2287 23.9788 15.4648 23.6875 15.4648H15.8125C15.5213 15.4648 15.2852 15.2287 15.2852 14.9375C15.2852 14.6463 15.5213 14.4102 15.8125 14.4102ZM15.8125 17.2227H22C22.2913 17.2227 22.5274 17.4588 22.5274 17.75C22.5274 18.0412 22.2913 18.2773 22 18.2773H15.8125C15.5213 18.2773 15.2852 18.0412 15.2852 17.75C15.2852 17.4588 15.5213 17.2227 15.8125 17.2227ZM15.2852 20.5625C15.2852 20.2713 15.5213 20.0352 15.8125 20.0352H20.3125C20.6038 20.0352 20.8399 20.2713 20.8399 20.5625C20.8399 20.8537 20.6038 21.0898 20.3125 21.0898H15.8125C15.5213 21.0898 15.2852 20.8537 15.2852 20.5625Z",
    fill: "#4251DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22080_156436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22080_156436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.314a183b39bc9f83c392a0f6c8ea9a83.svg";
export { ForwardRef as ReactComponent };